@if (item) {
  <app-icon
    [src]="item.icon || '/assets/icons/question.webp'"
    [width]="'48px'" [height]="'48px'"
[lazy]="true" [draggable]="false">
  </app-icon>
}
